/*
 *
 * */

import FilterFactory from '@/lib/filterFactory';

export default class ShopsFilter {
    filterHandlers = {
        update: 'administratorsFilter/updateFilter',
        reset: 'administratorsFilter/resetFilter',
        resetState: 'administratorsFilter/resetFilterState',
        removeSelected: 'administratorsFilter/removeSelectedFilter',
    };
    filterModel: Record<string, any>;

    constructor() {
        const filter = new FilterFactory();

        filter.createSearchEntity('fullName');
        filter.setPlaceholder('fullName', 'По имени');
        filter.setName('fullName', 'search_fullName');
        filter.setPreviewName('fullName', 'Имя');
        filter.setClassName('fullName', 'col-1-row-1');
        filter.setIconClassName('fullName', 'icon-store');
        filter.setAction('fullName', 'administratorsFilter/updateSearch');

        filter.createSearchEntity('email');
        filter.setPlaceholder('email', 'По Email');
        filter.setName('email', 'search_email');
        filter.setPreviewName('email', 'Email');
        filter.setClassName('email', 'col-1-row-2');
        filter.setIconClassName('email', 'icon-email');
        filter.setAction('email', 'administratorsFilter/updateSearch');

        filter.createSearchEntity('phone');
        filter.setPlaceholder('phone', 'По телефону');
        filter.setName('phone', 'search_phone');
        filter.setPreviewName('phone', 'Телефон');
        filter.setClassName('phone', 'col-2-row-1');
        filter.setIconClassName('phone', 'icon-phone');
        filter.setAction('phone', 'administratorsFilter/updateSearch');

        filter.createSearchEntity('clinicTitle');
        filter.setPlaceholder('clinicTitle', 'По клинике');
        filter.setName('clinicTitle', 'search_fullMarketName');
        filter.setPreviewName('clinicTitle', 'Клиника');
        filter.setClassName('clinicTitle', 'col-2-row-2');
        filter.setIconClassName('clinicTitle', 'icon-store');
        filter.setAction('clinicTitle', 'administratorsFilter/updateSearch');

        filter.createCheckboxEntity('withInactive');
        filter.setIconClassName('withInactive', 'icon-check-mark');
        filter.setName('withInactive', 'checkbox_activity');
        filter.setPreviewName('withInactive', 'Неактив');
        filter.setCheckboxList('withInactive', [
            {
                id: '0',
                name: 'Показывать деактивированные',
                value: 'withInactive',
                checked: false,
            }
        ]);
        filter.setAction('withInactive', 'administratorsFilter/updateCheckbox');

        this.filterModel = filter.filterModel;
    }
}
